const E = {
  NoReports: 'No Reports found. Please try again later or create a custom report',
  'Create Custom Report': 'Create Custom Report',
  'Report Name': 'Report Name',
  'Created On': 'Created On',
  'Download Report': 'Download Report',
};

const F = {
  NoReports: 'Aucun rapport ne correspond aux critères de recherche. Réessayez plus tard ou créez un rapport personnalisé.',
  'Create Custom Report': 'Créer un rapport personnalisé',
  'Report Name': 'Titre du rapport',
  'Created On': 'Créé le',
  'Download Report': 'Télécharger le rapport',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/reports.js